<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddDepartment"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed overflow-y-auto max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Add Deparments to {{ selectedRow.Name }}</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="">
              <div v-for="(department, index) in departments" :key="index">
                <p class="hidden">{{ department }}</p>
                <div class="grid grid-cols-2 gap-5 items-center my-4">
                  <div class="text-sm">
                    <label class="block pb-1 text-xs">Department</label>
                    <select
                      required
                      v-model="departments[index].department"
                      class="p-2 bg-gray-200 rounded-full w-full"
                    >
                      <option
                        v-for="(dept, index) in saved_departments"
                        :key="index"
                        v-bind:value="dept.Id"
                      >
                        {{ dept.Name }}
                      </option>
                    </select>
                  </div>
                  <div class="text-sm">
                    <label class="block pb-1 text-xs">Line Manager</label>
                    <select
                      v-model="departments[index].lineManager"
                      class="p-2 bg-gray-200 rounded-full w-full"
                    >
                      <option v-for="manager in linemanagers" :key="manager.Id">
                        {{ manager.FullName }}
                      </option>
                    </select>
                  </div>
                  <div v-show="index != 0">
                    <label class="text-sm invisible">s</label>
                    <button
                      type="button"
                      @click="removeDepartment(index)"
                      class="bg-gray-500 block text-white text-xs p-1"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
export default {
  name: "CompanySetupAddDepartment",
  props: ["showAddDepartment", "selectedRow"],
  components: { Loader },
  data() {
    return {
      saved_departments: [],
      employees: [],
      linemanagers: [],
      info: {
        Name: null,
      },
      departments: [
        {
          department: null,
          lineManager: null,
        },
      ],
      create_error: null,
      loading: false,
    };
  },
  created() {
    this.getDepartments();
    this.getLinemanagers();
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    addDepartment() {
      this.departments.push({
        department: null,
        lineManager: null,
      });
    },
    removeDepartment(index) {
      this.departments.splice(index, 1);
    },
    create() {
      this.loading = true;
      let data = {
        LocationId: this.selectedRow.Id,
        DepartmentId: this.departments[0].department,
        // LineManagerId: this.linemanagers.find(
        //   (manager) =>
        //     manager.FullName.toLowerCase() ===
        //     this.departments[0].lineManager.toLowerCase()
        // ).Id,
      };

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .post(
          `${this.getOrganization}/setup/location/departments/${this.$ApiVersion}/create`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess");
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.saved_departments = response.data.Data;
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
    getLinemanagers() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/linemanagers/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            //console.log(response);
            if (response.data.StatusCode == 200) {
              this.linemanagers = response.data.Data;
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
